"use strict";
exports.__esModule = true;
var TextCacheEntry = /** @class */ (function () {
    function TextCacheEntry() {
    }
    return TextCacheEntry;
}());
exports.TextCacheEntry = TextCacheEntry;
var TextCache = /** @class */ (function () {
    function TextCache(font, color) {
        this.canvas = null;
        this.context = null;
        this.nextX = 0;
        this.nextY = 50;
        this.cacheEntries = {};
        this.canvas = document.createElement('canvas');
        //window.document.body.appendChild(this.canvas);
        this.canvas.width = 5000;
        this.canvas.height = 100;
        this.context = this.canvas.getContext('2d');
        this.context.font = font;
        this.context.fillStyle = color;
    }
    TextCache.prototype.createTextCacheEntry = function (text) {
        this.context.fillText(text, this.nextX, this.nextY);
        var size = this.context.measureText(text);
        var entry = new TextCacheEntry();
        entry.height = 20;
        entry.width = size.width;
        entry.x = this.nextX;
        entry.y = this.nextY;
        entry.text = text;
        this.nextX += entry.width + 10;
        this.cacheEntries[text] = entry;
        return entry;
    };
    TextCache.prototype.drawTextCacheEntry = function (destinationContext, destinationX, destinationY, text) {
        var cacheEntry = this.cacheEntries[text];
        if (cacheEntry == null) {
            cacheEntry = this.createTextCacheEntry(text);
        }
        destinationContext.drawImage(this.canvas, cacheEntry.x, cacheEntry.y - cacheEntry.height, Math.round(cacheEntry.width), Math.round(cacheEntry.height), Math.round(destinationX), Math.round(destinationY), Math.round(cacheEntry.width), Math.round(cacheEntry.height));
    };
    return TextCache;
}());
exports.TextCache = TextCache;
//# sourceMappingURL=text-cache.js.map